import { Grid, styled } from "@mui/material";
import React, { useState } from "react";
import GuestImage from "../../assets/visitors.png";
import VechileImge from "../../assets/vechileIcon.jpg";
import MaterialInward from "../../assets/Cotton.webp";
import MaterialReturnable from "../../assets/spareParts.png";
import KeyImage from "../../assets/keyImage.png";
import BgImage from "../../assets/bg5.jpg";
import MaterialOutwardIcon from "../../assets/MaterialOutward.jpg";
import DialogModal from "../Dialog";
import MilkComponent from "./MilkComponent";
import GuestComponent from "./GuestComponent";
import VechileComponent from "./VechileComponent";
import KeyManagement from "./KeyManagement";
import MaterialOutward from "./MaterialOutwardComponent";
import MaterialInwardComponent from "./MaterialnwardComponent";
import MaterialReturnableComponent from "./MaterialReturnableComponent";
import AavinImage from "../../assets/milk1.png";

const DashboardWrapper = styled(Grid)`
  padding: 30px 80px;
  background: #fff;
  min-height: 80vh;
  overflow: scroll;
`;

const Card = styled(Grid)`
  border-radius: 15px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  background: #fff;
  
  box-shadow: 1px 1px rgba(16, 24, 40, 0.12);
  transition: box-shadow 0.4s ease;
  transition: background-color 0.4s ease;

  &:hover {
    background-color: #F0F0F0;
    box-shadow: 1px 1px rgba(16, 24, 40, 0.2);
  }
`;

function Dashboard() {
  const [modelToggle, setModelToggle] = useState(false);
  const [moduleType, setModuleType] = useState("");

  return (
    <DashboardWrapper
      container
      justifyContent={"space-between"}
      columnGap={2}
      rowGap={3}
      style={{
        backgroundImage: `url(${BgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Card
        item
        container
        xs={12}
        md={5}
        lg={3}
        xl={3}
        justifyContent={"center"}
        alignItems={"center"}
        onClick={() => {
          setModelToggle(true);
          setModuleType("MILK");
        }}
      >

        <img src={AavinImage} alt="cow" height={50} width={50} />
        <Grid item xs={12}>
          Milk / பால்
        </Grid>
      </Card>
      <Card
        item
        container
        xs={12}
        md={5}
        lg={3}
        xl={3}
        justifyContent={"center"}
        alignItems={"center"}
        onClick={() => {
          setModelToggle(true);
          setModuleType("GUEST");
        }}
      >
        <img src={GuestImage} alt="guest" height={50} width={50} />
        <Grid item xs={12}>
          Guest / விருந்தினர்
        </Grid>
      </Card>
      <Card
        item
        container
        xs={12}
        md={5}
        lg={3}
        xl={3}
        justifyContent={"center"}
        alignItems={"center"}
        onClick={() => {
          setModelToggle(true);
          setModuleType("VECHILE_MANAGEMENT");
        }}
      >
        <img src={VechileImge} alt="guest" height={50} width={50} />
        <Grid item xs={12}>
          Vechile / வாகனம்
        </Grid>
      </Card>
      <Card
        item
        container
        xs={12}
        md={5}
        lg={3}
        xl={3}
        justifyContent={"center"}
        alignItems={"center"}
        onClick={() => {
          setModelToggle(true);
          setModuleType("MATERIAL_INWARD");
        }}
      >
        <img src={MaterialInward} alt="guest" height={50} width={50} />
        <Grid item xs={12}>
          Materials Inward / உள்வரும் பொருள்
        </Grid>
      </Card>
      <Card
        item
        container
        xs={12}
        md={5}
        lg={3}
        xl={3}
        justifyContent={"center"}
        alignItems={"center"}
        onClick={() => {
          setModelToggle(true);
          setModuleType("KEY_MANAGEMENT");
        }}
      >
        <img src={KeyImage} alt="guest" height={50} width={50} />
        <Grid item xs={12}>
          Key Management / சாவி மேலாண்மை
        </Grid>
      </Card>
      <Card
        item
        container
        xs={12}
        md={5}
        lg={3}
        xl={3}
        justifyContent={"center"}
        alignItems={"center"}
        onClick={() => {
          setModelToggle(true);
          setModuleType("MATERIAL_OUTWARD");
        }}
      >
        <img src={MaterialOutwardIcon} alt="guest" height={50} width={50} />
        <Grid item xs={12}>
          Materials Outward / வெளிச்செல்லும் பொருள்
        </Grid>
      </Card>
      <Card
        item
        container
        xs={12}
        md={5}
        lg={3}
        xl={3}
        justifyContent={"center"}
        alignItems={"center"}
        onClick={() => {
          setModelToggle(true);
          setModuleType("MATERIALS_RETURNABLE");
        }}
      >
        <img src={MaterialReturnable} alt="guest" height={50} width={50} />
        <Grid item xs={12}>
          Materials Returnable / திரும்பப் பெறக்கூடிய பொருள்
        </Grid>
      </Card>

      <DialogModal toggleModal={modelToggle} setToggleModal={setModelToggle}>
        {(() => {
          switch (moduleType) {
            case "MILK":
              return <MilkComponent setModelToggle={setModelToggle} />;
            case "GUEST":
              return <GuestComponent setModelToggle={setModelToggle} />;
            case "VECHILE_MANAGEMENT":
              return <VechileComponent setModelToggle={setModelToggle} />;
            case "MATERIAL_INWARD":
              return (
                <MaterialInwardComponent setModelToggle={setModelToggle} />
              );
            case "KEY_MANAGEMENT":
              return <KeyManagement setModelToggle={setModelToggle} />;
            case "MATERIAL_OUTWARD":
              return <MaterialOutward setModelToggle={setModelToggle} />;
            default:
              return (
                <MaterialReturnableComponent setModelToggle={setModelToggle} />
              );
          }
        })()}
      </DialogModal>
    </DashboardWrapper>
  );
}

export default Dashboard;
